/**
 * Length-of-stay pricing helpers — mirror of `backend/pricing.py`.
 *
 * The tier table is fetched from `/api/pricing/tiers` so editing the backend
 * config file changes the site instantly. `DEFAULT_TIERS` is only used as a
 * fallback if the network fetch fails.
 */

export const DEFAULT_TIERS = [
  { min_nights: 1,  max_nights: 6,    discount_pct: 0 },
  { min_nights: 7,  max_nights: 13,   discount_pct: 10 },
  { min_nights: 14, max_nights: 27,   discount_pct: 15 },
  { min_nights: 28, max_nights: 59,   discount_pct: 22 },
  { min_nights: 60, max_nights: 89,   discount_pct: 28 },
  { min_nights: 90, max_nights: null, discount_pct: 32 },
];

export function findTier(tiers, nights) {
  const list = tiers && tiers.length ? tiers : DEFAULT_TIERS;
  if (!nights || nights < 1) return list[0];
  for (const t of list) {
    const lo = t.min_nights;
    const hi = t.max_nights;
    if (nights >= lo && (hi == null || nights <= hi)) return t;
  }
  return list[list.length - 1];
}

export function nextTier(tiers, nights) {
  const list = tiers && tiers.length ? tiers : DEFAULT_TIERS;
  const current = findTier(list, nights);
  const candidates = list
    .filter((t) => t.min_nights > nights && t.discount_pct > current.discount_pct)
    .sort((a, b) => a.min_nights - b.min_nights);
  return candidates[0] || null;
}

export function calculateQuote(tiers, pricePerNight, nights) {
  if (!nights || nights < 1 || !pricePerNight) {
    return {
      nights: Math.max(0, nights || 0),
      price_per_night: Math.round(pricePerNight || 0),
      gross: 0, discount_pct: 0, discount_amount: 0, total: 0, per_night: 0,
      tier_min_nights: 1,
    };
  }
  const tier = findTier(tiers, nights);
  const grossRaw = pricePerNight * nights;
  const total = Math.round(grossRaw * (1 - tier.discount_pct / 100));
  const gross = Math.round(grossRaw);
  return {
    nights,
    price_per_night: Math.round(pricePerNight),
    gross,
    discount_pct: tier.discount_pct,
    discount_amount: gross - total,
    total,
    per_night: Math.round(total / nights),
    tier_min_nights: tier.min_nights,
  };
}
